import { makeStyles } from 'tss-react/mui';

export default makeStyles()(theme => ({
    paper: {
        padding: theme.spacing(2)
    }
}))